import React from 'react';

const TouchableOpacity = ({
  onPress,
  disabled = false,
  activeOpacity = 0.7,
  style,
  children,
  ...props
}) => {
  const handleClick = (e) => {
    if (!disabled && onPress) {
      onPress(e);
    }
  };

  const defaultStyle = {
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled ? 0.5 : 1,
    transition: 'opacity 0.2s ease',
    userSelect: 'none',
  };

  const combinedStyle = {
    ...defaultStyle,
    ...(typeof style === 'object' && !Array.isArray(style) ? style : {}),
  };

  const handleMouseDown = (e) => {
    if (!disabled) {
      e.currentTarget.style.opacity = activeOpacity;
    }
  };

  const handleMouseUp = (e) => {
    if (!disabled) {
      e.currentTarget.style.opacity = 1;
    }
  };

  const handleMouseLeave = (e) => {
    if (!disabled) {
      e.currentTarget.style.opacity = 1;
    }
  };

  return (
    <div
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      style={combinedStyle}
      {...props}
    >
      {children}
    </div>
  );
};

export default TouchableOpacity;
